var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { makeVar } from "@apollo/client";
export var activeItemVar = makeVar(null);
var alpha = Array.from(Array(26)).map(function (e, i) { return i + 65; });
var letterOptions = __spreadArray([
    { __typename: "LetterInfo", letter: "#", count: 0 }
], alpha.map(function (char) { return ({
    __typename: "LetterInfo",
    letter: String.fromCharCode(char),
    count: 0,
}); }), true);
export var letterIndexVar = makeVar(letterOptions);
